import { Typography } from "@mui/material";
import { useDocumentTitle } from "./page";
import { ifNull } from "../common/utils";

export function PageTitle(props: { title: string; documentTitle?: string; }) {
    useDocumentTitle(ifNull(props.documentTitle, props.title));
    return <Typography component="h1" variant="h4" mb={2}>{props.title}</Typography>;
}
